/* @flow strict */

import { toast } from 'react-toastify';
import axios from 'axios';
import Credentials from './Credentials';

const queryString = require('query-string');

const headers = {
  'Content-Type': 'application/json',
  'X-Requested-With': 'XMLHttpRequest'
};

const next = async (response: Response): Promise<any> => {
  const result  = await response.json();

  if (response.status >= 300) {
    const errors = _.get(result, 'errors', []);

    if (_.size(errors) > 0) {
      _.forEach(errors, (error: { msg: string }) => {
        if (_.has(error, 'msg')) {
          toast.error(_.get(error, 'msg'));
        }
      });
    } else {
      toast.error('Failure!');
    }

    if (response.status === 401) {
      Credentials.logout();
    } else {
      throw response;
    }
  }

  return result;
};

const CancelToken = axios.CancelToken;

const cancelGetRequest = {};

const cancelGetWithHeadersRequest = {};

const cancelPostRequest = {};

const cancelPutRequest = {};

const cancelDeleteRequest = {};

export const GET_WITH_REDIRECT = async (url: string, options: any): Promise<any> => {
  if (cancelGetWithHeadersRequest[url] !== undefined) {
    cancelGetWithHeadersRequest[url]();
  }

  return await axios({
    method: 'get',
    url,
    cancelToken: new CancelToken((c: any): any => {
      cancelGetWithHeadersRequest[url] = c;
    }),
    crossDomain: true,
    headers: {
      ...headers,
      ...Credentials.getHeaders(),
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'GET, PUT, POST, DELETE',
      'Access-Control-Allow-Headers': 'Origin, X-Requested-With, XMLHttpRequest, Content-Type, Accept'
    }
  })
    .then((response: any): any => {
        return response;
    })
    .catch((error: any): Promise<any> => {
      const result = error.response;

      if (result.status === 302) {
        let _location = _.get(result, 'data.headers.location', null);

        const parsed = queryString.parse(_location);

        if (options && _.get(options, 'chnageRedirect', false)) {
          const originRedirectUri = parsed.redirect_uri;

          // console.log(_location);
          // console.log(originRedirectUri);
          // console.log(options.chnageRedirect);

          _location = _.replace(_location, originRedirectUri, options.chnageRedirect);
        }

        if (_location) {
          window.location.href = _location;
        } else {
          console.warn('"Location" headers are not preset');
        }

        return result.data;
      }

      console.log(error);

      return Promise.reject(result);
    });
};

export const GET = async (url: string, isWidget?: boolean | null, extraOptions?: {} | null): Promise<any> => {
  if (cancelGetRequest[url.split('?')[0]] !== undefined) {
    cancelGetRequest[url.split('?')[0]]();
  }

  let options = {
    method: 'get',
    url,
    ...extraOptions,
    cancelToken: new CancelToken((c: any): any => {
      cancelGetRequest[url.split('?')[0]] = c;
    }),
    headers: {
      ...headers,
      ...Credentials.getHeaders(isWidget)
    }
  };

  if (extraOptions) {
    options = {
      ...options,
      ...extraOptions
    };
  }

  return await axios(options)
    .then((response: any): any => {
        return response.data;
    })
    .catch((error: any): Promise<any> => {
      Credentials.logoutByExpOrError(error, isWidget);

      const result = error.response;

      return Promise.reject(result);
    });
};

export const POST = async (url: string, data: {}, o: any, contentType: string, isWidget: boolean | null, preventCancelation: boolean): Promise<any> => {
  if (cancelPostRequest[url] !== undefined && !preventCancelation) {
    cancelPostRequest[url]();
  }

  return await axios({
    method: 'post',
    url,
    cancelToken: new CancelToken((c: any): any => {
      cancelPostRequest[url] = c;
      }),
    data,
    headers: {
      ...headers,
      'Content-Type': contentType ? contentType : 'application/json',
      ...Credentials.getHeaders(isWidget)
    }
  })
    .then((response: any): any => {
        return response.data;
    })
    .catch((error: any): Promise<any> => {
      Credentials.logoutByExpOrError(error, isWidget);

      const result = error.response;

      console.log(error);

      return Promise.reject(result);
    });
};

export const PUT = async (url: string, data: {}, o: any, contentType: string, isWidget: any): Promise<any> => {
  if (cancelPutRequest[url] !== undefined) {
    cancelPutRequest[url]();
  }

  return await axios({
    method: 'put',
    url,
    cancelToken: new CancelToken((c: any): any => {
      cancelPutRequest[url] = c;
}),
    data,
    headers: {
      ...headers,
      'Content-Type': contentType ? contentType : 'application/json',
      ...Credentials.getHeaders(isWidget)
    }
  })
    .then((response: any): any => {
        return response.data;
    })
    .catch((error: any): Promise<any> => {
      Credentials.logoutByExpOrError(error, isWidget);

      const result = error.response;

      console.log(error);

      return Promise.reject(result);
    });
};

export const DELETE = async (url: string, data: {}, isWidget: any): Promise<any> => {
  if (cancelDeleteRequest[url] !== undefined) {
    cancelDeleteRequest[url]();
  }

  return await axios({
    method: 'delete',
    url,
    data,
    cancelToken: new CancelToken((c: any): any => {
      cancelDeleteRequest[url] = c;
    }),
    headers: {
      ...headers,
      ...Credentials.getHeaders()
    }
  })
    .then((response: any): any => {
      return response.data;
    })
    .catch((error: any): Promise<any> => {
      Credentials.logoutByExpOrError(error, isWidget);

      const result = error.response;

      console.log(error);

      return Promise.reject(result);
    });
};
